// extracted by mini-css-extract-plugin
module.exports = {"luxuryGRDSlide":"style_luxuryGRDSlide__BZlxF"};